import styled, { css } from 'styled-components';
import { getSpacingToken, getToken, Size } from '@optimus-web/core';

export const getChipInputContainerHeight = ({ size }: { size?: Size }) => {
    switch (size) {
        case 'small':
            return getToken('sizing400');
        case 'medium':
            return getToken('sizing500');
        case 'large':
            return getToken('sizing600');
        case 'extraLarge':
            return getToken('sizing700');
        default:
            return getToken('sizing500');
    }
};

export const ValueContainerElement = styled.div<{ size?: Size }>`
    min-height: calc(${getChipInputContainerHeight}px - ${getToken('borderWidth150')}px * 2);
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    padding: 6px ${getSpacingToken('200')}px;
    box-sizing: border-box;
    min-width: 0;
    cursor: text;

    & > * {
        margin-top: 1px;
        margin-bottom: 1px;

        &:not(:last-child) {
            margin-right: ${getSpacingToken('50')}px;
        }
    }

    ${(props) =>
        props.size === 'small' &&
        css`
            padding: 2px ${getSpacingToken('100')}px;
        `}

    ${(props) =>
        props.size === 'large' &&
        css`
            padding: 9px ${getSpacingToken('200')}px;
        `}

    ${(props) =>
        props.size === 'extraLarge' &&
        css`
            padding: 12px ${getSpacingToken('200')}px;
        `}
`;
